import { usePage } from "@inertiajs/react";
import * as React from "react";

import type { GalleryImageSummary } from "@/types";

export function GalleryCarousel() {
  const { gallery_images } = usePage<{ gallery_images: GalleryImageSummary[] }>().props;
  const [images, setImages] = React.useState<GalleryImageSummary[]>([]);

  React.useEffect(() => {
    if (Array.isArray(gallery_images) && gallery_images.length > 0) {
      setImages(gallery_images);
    } else {
      setImages([]);
    }
  }, [gallery_images]);

  if (images.length === 0) {
    return null;
  }

  return (
    <div className="relative grid grid-cols-2 items-center gap-1 lg:grid-cols-3 xl:grid-cols-4">
      {images.map((image, index) => (
        <figure key={`${image.src}-${index}`} className="group relative transition-transform duration-500 ease-out">
          <div className="aspect-[40/21] overflow-hidden rounded-lg border bg-gray-50/40 shadow-xl transition-transform duration-500 group-hover:-translate-y-1 dark:bg-gray-900/40 dark:ring-white/5">
            <img
              src={image.src}
              alt={image.alt}
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
              loading="lazy"
              fetchPriority={index < 6 ? "high" : "low"}
              decoding="async"
            />
          </div>
        </figure>
      ))}
    </div>
  );
}
